export default {
      id: "preview-usage",
      viewBox: "0 0 512 512",
      url: __webpack_public_path__ + "img/svg-sprite.svg#preview",
      toString: function () {
        return this.url;
      }
    }